import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-login-email',
  templateUrl: './login-email.component.html',
  styleUrls: ['./login-email.component.scss']
})
export class LoginEmailComponent implements OnInit {

    public show: boolean = false;
    public loginForm: FormGroup;
    public errorMessage: any;

    showLogin: boolean = true;
    showOTP: boolean = false;
    showUpdateMobileNumber: boolean = false;
    showPasswordLogin: boolean = false;
    EnablePasswordLogin: boolean = false;

    password_button_text: string = 'Log in'
    otp_button_text: string = 'Continue';
    otp_emailAddress: string = '';

    otp: string;
    onOtpChange(otp) {
        this.otp = otp;
    }

    userName: string = "";
    password: string = "";

    btnDisabled = false;

    loginData: any = {
        userName: "",
        password: ""
    }

    myControl = new FormControl();
    mobileLoginForm = new FormGroup({
        phone: new FormControl("", [Validators.required])
    });
    showPasswordPanel() {
        this.showOTP = false;
        this.showPasswordLogin = true;
    }
    showOTPPanel() {
        this.showOTP = true;
        this.showPasswordLogin = false;
    }
    constructor(public authenticationService: AuthenticationService,
        private common: CommonService,
        private _activatedRoute: ActivatedRoute,
        private router: Router) {

        let authorizationData: any = this.authenticationService._getLocalStorage("authorizationData");
        if (authorizationData != null) {
            if (authorizationData.isAuth) {
                var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
                if (returnUrl != "/")
                    this.router.navigate([returnUrl]);
                else {
                    this.router.navigate(['/home/news-feed']);
                    //this.router.navigate(['/dashboard/default']);
                }
            }
        }
    }

    ngOnInit() {
    }

    showPassword() {
        this.show = !this.show;
    }

    // Login With Google
    loginGoogle() {
        //this.authService.GoogleAuth();
    }

    // // Login With Twitter
    loginTwitter(): void {
        //this.authService.signInTwitter();
    }

    // Login With Facebook
    loginFacebook() {
        //this.authService.signInFacebok();
    }


    getUserIpLocation() {
        this.authenticationService.getUserIpLocation().subscribe(
            (res: any) => {
                //TODO: Check the output of the service - the below line
                //this.rootScope.userAddress = res;
                console.log(res);
            },
            (err: any) => {
                console.error("getUserIpLocation", err);
            })
    }

    continue_email() {
        debugger;
        if (this.userName == null) {
            this.common.ShowMessage('error', 'Invalid email address', '');
        }
        else if (this.userName == '') {
            this.common.ShowMessage('error', 'Invalid email address', '');
        }
        else {
            //verify mobile number
            this.authenticationService.verifyEmailAddress(this.userName).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success) {
                        this.otp_emailAddress = this.userName;
                        this.authenticationService._loginData.loginType = "email";
                        this.authenticationService._loginData.email = this.userName;
                        this.authenticationService._loginData.userType = res.data.userType;

                        if (res.data.userType == "registered") {
                            this.otp_button_text = "Log in";
                            this.EnablePasswordLogin = true;
                        }

                        this.showOTP = true;
                        this.showLogin = false;


                    }
                    else {
                        console.error("verifyEmailAddress Error", res.error_message);
                    }

                },
                (err: any) => {
                    console.error("verifyEmailAddress Error", err);
                }
            );


        }
    }

    userId: string;
    save_mobile_login() {
        this.authenticationService.updateUserMobileNumber({
            mobile: this.mobileLoginForm.value.phone,
            userId: this.userId
        }).subscribe(
            (res: any) => {
                if (res.success) {
                    this.login(res.data);
                }
                else {
                    console.error("updateUserMobileNumber", res.error_message);
                }
            },
            (err: any) => {
                console.error("updateUserMobileNumber", err);
            }
        );
    }
    continue_otp() {

        if (this.otp != "") {
            var obj = {
                verifyMobile: false,
                Mobile: "",
                Email: this.authenticationService._loginData.email,
                OTP: this.otp,
                userType: this.authenticationService._loginData.userType
            };
            this.authenticationService.verifyOTP(obj).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success) {
                        if (res.data.otpMatched) {
                            // if usertype is registered //login
                            //else register
                            if (this.authenticationService._loginData.userType == "new") {
                                this.router.navigate(['/auth/register']);
                            }
                            else if (res.data.user.mobilePhone == null)
                            {
                                this.showUpdateMobileNumber = true;
                                this.showLogin = false;
                                this.showOTP = false;
                                this.showPasswordLogin = false;
                                this.userId = res.data.user.id;
                                //
                            }
                            else if (res.data.user.mobilePhone == ''){
                                this.showUpdateMobileNumber = true;
                                this.showLogin = false;
                                this.showOTP = false;
                                this.showPasswordLogin = false;
                                this.userId = res.data.user.id;
                                //
                            }
                            else {
                                this.login(res.data.user);
                            }
                        }
                        else {
                            this.common.ShowMessage('error', 'Invalid One-Time Passwprd (OTP)', '');
                        }
                    }
                    else {
                        console.error("VerifyMobileNumber Error", res.error_message);
                        this.common.ShowMessage('error', 'OTP Verification error, please try again later', '');
                    }
                },
                (err: any) => {
                    console.error("VerifyMobileNumber Error", err);
                    this.common.ShowMessage('error', 'OTP Verification error, please try again later', '');
                }
            );
        }
        else {
            this.common.ShowMessage('error', 'Invalid One-Time Passwprd (OTP)', '');
        }


    }

    login(userData: any) {

        //generate token

        let authorizationData: any = {
            id: userData.id,
            token: '',
            userName: userData.eMail,
            refreshToken: "",
            useRefreshTokens: false,
            isAuth: true,
            mobileNumber: userData.mobilePhone
        };

        this.authenticationService._setLocalStorage("authorizationUserData", JSON.stringify(userData));
        this.authenticationService._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
        this.authenticationService._authentication = authorizationData;
        this.authenticationService.userData = userData;

        //TODO: Pass the user ID
        //this.authenticationService._addUserLogin();

        this.getUserIpLocation();

        var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        if (returnUrl != "/")
            this.router.navigate([returnUrl]);
        else {

            this.router.navigate(['/home/news-feed']);
            //this.router.navigate(['/articles/all']);
        }

    }

    login_password() {
        if (this.userName === '' || this.password === '') {
            this.btnDisabled = false;
            this.common.ShowMessage('error', 'Please type your password!', "");
        }
        else {
            this.btnDisabled = true;
            this.loginData = {
                userName: this.userName,
                password: this.password
            };

            this.loginData.password = this.loginData.password.replace("#", "(*%23*)").replace("?", "(*%3F*)");

            this.authenticationService._login(this.loginData).subscribe(
                (userData: any) => {
                    if (userData.isAuthenticated) {

                        let authorizationData: any = {
                            id: userData['userData'].id,
                            token: userData['token'],
                            userName: this.loginData.userName,
                            refreshToken: "",
                            useRefreshTokens: false,
                            isAuth: true
                        };

                        this.authenticationService._setLocalStorage("authorizationUserData", JSON.stringify(userData['userData']));
                        this.authenticationService._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
                        this.authenticationService._authentication = authorizationData;
                        this.authenticationService.userData = userData['userData'];

                        //TODO: Pass the user ID
                        this.authenticationService._addUserLogin();

                        this.getUserIpLocation();

                        var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
                        if (returnUrl != "/")
                            this.router.navigate([returnUrl]);
                        else {
                            this.router.navigate(['/home/news-feed']);
                        }

                    }
                    else {
                        this.btnDisabled = false;
                        this.common.ShowMessage('error', 'Incorrect Email Address or Password', "");
                    }
                },
                (userDataError: any) => {
                    this.btnDisabled = false;
                    let error: any = userDataError;
                    console.error("userDataError", error);
                    this.common.ShowMessage('error', "Failed to login. Check with mygistec administrator", "")
                    // this.toastr.error(error['error_description'], 'Oops!');
                }
            );
        }
    }

}

